const AssetsPack = {
  icons: {
    ICON_LOGO: await import("../assets/svg/logo.svg"),
    ICON_4D: await import("../assets/svg/icon4d.svg"),
    ICON_LUCKY7: await import("../assets/svg/iconLucky7.svg"),
    ICON_ALL_GAMES: await import("../assets/svg/iconAllGames.svg"),
    ICON_BELL: await import("../assets/svg/iconBell.svg"),
    ICON_CLOSE: await import("../assets/svg/iconClose.svg"),
    ICON_CROSS: await import("../assets/svg/cross.svg"),
    ICON_LOGIN: await import("../assets/svg/log-in.svg"),
    ICON_MENU: await import("../assets/svg/menu.svg"),
    ICON_LOCK: await import("../assets/svg/iconLock.svg"),
    ICON_GO: await import("../assets/svg/iconGo.svg"),
    ICON_CHECK_GREEN_CIRCLE: await import("../assets/svg/checkmark-circle.svg"),
    ICON_CLOSE_RED_CIRCLE: await import("../assets/svg/close-circle.svg"),
    ICON_ARROW_RIGHT_GOLD_CIRCLE: await import(
      "../assets/svg/icon-circle-right-arrow.svg"
    ),
    DOWN_ARROW_ICON: await import("../assets/svg/downArrowIcon.svg"),
    REDIRECT_ARROW: await import("../assets/svg/redirectArrow.svg"),
    SEARCH: (await import("../assets/svg/search.svg")).default,
    SCRATCH_WIN: await import("../assets/svg/scratch_win.svg"),
    OBLIQUE_DOWN_ARROW: await import("../assets/svg/oblique_down_arrow.svg"),
    LEFT_ARROW: await import("../assets/svg/icArrowLeft.svg"),
    RIGHT_ARROW: await import("../assets/svg/icArrowRight.svg"),
    ICON_DOWNLOAD: await import("../assets/svg/iconDownload.svg"),
    ICON_LIVECHAT: await import("../assets/svg/iconLiveChat.svg"),
    ADD: await import("../assets/svg/iconAdd.svg"),
    CHAT: await import("../assets/svg/iconChat.svg"),

    PLAY_ICON: await import("../assets/svg/playbutton.svg"),
    ICON_TICK: await import("../assets/svg/tick.svg"),
    ICON_ANDROID: await import("../assets/svg/icon-android-default.svg"),
    ICON_IOS: await import("../assets/svg/icon-apple-default.svg"),
    ICON_WEB: await import("../assets/svg/icon-webapp-default.svg"),

    ICON_JOKERPRO_LUCKY7_1: await import(
      "../assets/svg/jokerProLucky7Icon1.svg"
    ),
    ICON_JOKERPRO_LUCKY7_2: await import(
      "../assets/svg/jokerProLucky7Icon2.svg"
    ),
    ICON_JOKERPRO_LUCKY7_3: await import(
      "../assets/svg/jokerProLucky7Icon3.svg"
    ),

    ICON_JOKERPRO_LOTTO4D_1: await import(
      "../assets/svg/jokerProLotto4dIcon1.svg"
    ),
    ICON_JOKERPRO_LOTTO4D_2: await import(
      "../assets/svg/jokerProLotto4dIcon2.svg"
    ),
    ICON_JOKERPRO_LOTTO4D_3: await import(
      "../assets/svg/jokerProLotto4dIcon3.svg"
    ),

    ICON_JOKERSCRATCH_TURBO_1: await import(
      "../assets/svg/jokerScratchTurboIcon1.svg"
    ),
    ICON_JOKERSCRATCH_TURBO_2: await import(
      "../assets/svg/jokerScratchTurboIcon2.svg"
    ),
    ICON_JOKERSCRATCH_TURBO_3: await import(
      "../assets/svg/jokerScratchTurboIcon3.svg"
    ),

    ICON_JOKERSCRATCH_SUGAR_1: await import(
      "../assets/svg/jokerScratchSugarIcon1.svg"
    ),
    ICON_JOKERSCRATCH_SUGAR_2: await import(
      "../assets/svg/jokerScratchSugarIcon2.svg"
    ),
    ICON_JOKERSCRATCH_SUGAR_3: await import(
      "../assets/svg/jokerScratchSugarIcon3.svg"
    ),

    ICON_DOWNLOAD_GOLD: await import("../assets/svg/downloadIconGold.svg"),

    SUPPORT_WALLET: await import("../assets/svg/supportWallet.svg"),
    SUPPORT_ACCOUNT: await import("../assets/svg/supportAccount.svg"),
    SUPPORT_LUCKY7: await import("../assets/svg/supportLucky7.svg"),
    SUPPORT_4D: await import("../assets/svg/support4d.svg"),
    SUPPORT_SCRATCH: await import("../assets/svg/supportScratchWin.svg"),
    SUPPORT_ALL_GAMES: await import("../assets/svg/supportAllGames.svg"),
  },
  logos: {
    JOKER_PRO_LOGO: await import("../assets/svg/joker-plus-logo.svg"),
  },
  backgrounds: {
    BACKGROUND_LOGIN: (await import("../assets/background/background.jpg"))
      .default,
    FOOTER_CARD_BACKGROUND_DEPOSIT: (
      await import("../assets/background/deposit_bgimage.png")
    ).default,
    FOOTER_CARD_BACKGROUND_WITHDRAW: (
      await import("../assets/background/withdraw_bgimage.png")
    ).default,
    FOOTER_CARD_BACKGROUND_GET_STARTED: (
      await import("../assets/background/footer_bgimage.png")
    ).default,

    BG_MAIN_SCRATCH: (
      await import("../assets/image/Main/heroHomeJokerScratch@1x.webp")
    ).default,
    BG_MAIN_JOKER_PRO: (
      await import("../assets/image/Main/heroHomeJokerPro@1x.webp")
    ).default,
  },
  videos: {
    JOKER_TURBO_HOME: (await import("../assets/video/jokerTurbo.mp4")).default,

    JOKER_PRO_HOME: (await import("../assets/video/jokerProHome.mp4")).default,
    JOKER_PRO_LOGO_VIDEO: (await import("../assets/video/jPlusVideo-min.mp4"))
      .default,
    LUCKY7_LIST_INDICATOR: (await import("../assets/video/videoIconLucky7.mp4"))
      .default,
    FOUR_D_LIST_INDICATOR: (await import("../assets/video/videoIcon4D.mp4"))
      .default,
    ALL_GAMES: (await import("../assets/video/videoIconAllGames.mp4")).default,
    TURBO_LIST_INDICATOR: (await import("../assets/video/videoIconTurbo.mp4"))
      .default,
    SUGAR_LIST_INDICATOR: (await import("../assets/video/videoIconSugar.mp4"))
      .default,

    LANDSCAPE_FOUR_D_CARD: (
      await import("../assets/video/landscapeBannerLotto4D.mp4")
    ).default,
    LANDSCAPE_LUCKY7: (await import("../assets/video/luckyLandscapeBg.mp4"))
      .default,

    LANDSCAPE_TURBO_SCRATCH: (
      await import("../assets/video/landscapeBannerTurboScratch.mp4")
    ).default,

    LANDSCAPE_SUGAR_SCRATCH: (
      await import("../assets/video/landscapeBannerSugarScratch.mp4")
    ).default,

    FOOTER: (await import("../assets/video/footerVideo.mp4")).default,
    DOWNLOAD_STEP_1: (await import("../assets/video/download_step1.mp4"))
      .default,
    DOWNLOAD_STEP_2: (await import("../assets/video/download_step2.mp4"))
      .default,
    DOWNLOAD_STEP_3: (await import("../assets/video/download_step3.mp4"))
      .default,
    DOWNLOAD_STEP_4: (await import("../assets/video/download_step4.mp4"))
      .default,

    JOKER_LUCKY7_GSAP: (await import("../assets/video/lucky7Gsap.mp4")).default,
    JOKER_LOTTO4D_GSAP: (await import("../assets/video/4DlottoGsap.mp4"))
      .default,

    JOKERPRO_TURBO_GSAP: (await import("../assets/video/turboGsap.mp4"))
      .default,
  },

  tutorial_videos_url: {
    AUS_4D:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped-Aus-4D-tutorial-min.mp4",
    LUCKY_BALL:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_Lucky_Ball_Tutorial-min.mp4",
    THREE_BALL:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_Three_Ball_tutorial-min.mp4",
    ODDS_EVEN:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_Odds_Evens_Tutorial-min.mp4",
    MISS_MATCH:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_MissMatch_tutorial-min.mp4",
    SINGLE_BET:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_SingleBet_tutorial-min.mp4",

    TRDAITIONAL_BET:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_Traditional_Bet_tutorial-min.mp4",
    PACKAGE_BET:
      "https://mjproductions.app/jokerplus_faqs/wp-content/uploads/2024/06/Cropped_Package_Bet_Tutorial-min.mp4",
  },

  images: {
    MATCH_SYMBOL_1: (await import("../assets/image/matchSymbol01@2x.jpg"))
      .default,
    MATCH_SYMBOL_2: (await import("../assets/image/matchSymbol02@2x.jpg"))
      .default,
    MATCH_SYMBOL_3: (await import("../assets/image/matchSymbol03@2x.jpg"))
      .default,

    JOKER_SUPPORT_WOMAN_HEADSET: (
      await import("../assets/image/jokerSupportWomanHeadSet.png")
    ).default,

    MOBILE_LUCKY7: (await import("../assets/image/imgMobileLucky7@2x.png"))
      .default,

    MOBILE_LUCKY7_AUS4D: (
      await import("../assets/image/imgMobileLucky7Aus4d@2x.png")
    ).default,

    MOBILE_LUCKY7_LUCKY_BALL: (
      await import("../assets/image/imgMobileLucky7LuckyBall@2x.png")
    ).default,

    MOBILE_LUCKY7_MISMATCH_BALL: (
      await import("../assets/image/imgMobileLucky7MissMatch@2x.png")
    ).default,

    MOBILE_LUCKY7_ODDS_EVEN: (
      await import("../assets/image/imgMobileLucky7oddsEvens@2x.png")
    ).default,

    MOBILE_LUCKY7_THREE_BALL: (
      await import("../assets/image/imgMobileLucky7ThreeBall@2x.png")
    ).default,

    MOBILE_FOUR_D_LOTTO: (
      await import("../assets/image/imgMobile4dHome@2x.png")
    ).default,

    MOBILE_FOUR_D_SINGLE_BET: (
      await import("../assets/image/imgMobile4DSingleBet@2x.png")
    ).default,

    MOBILE_FOUR_D_TRADITIONAL_BET: (
      await import("../assets/image/imgMobile4DTraditional@2x.png")
    ).default,

    MOBILE_FOUR_D_PRO_BET: (
      await import("../assets/image/imgMobile4DProBetting@2x.png")
    ).default,

    MOBILE_FOUR_D_PACKAGE_BET: (
      await import("../assets/image/imgMobile4DPackageBet@2x.png")
    ).default,

    MOBILE_TURBO_SCRATCH: (
      await import("../assets/image/imgMobileJokerScratch@2x.png")
    ).default,

    MOBILE_TURBO_SCRATCH_2: (
      await import("../assets/image/imgMobileJokerScratch02@2x.png")
    ).default,

    MOBILE_TURBO_SCRATCH_3: (
      await import("../assets/image/imgMobileJokerScratch03@2x.png")
    ).default,

    MOBILE_TURBO_SCRATCH_4: (
      await import("../assets/image/imgMobileJokerScratch04@2x.png")
    ).default,

    MOBILE_SUGAR_SCRATCH: (
      await import("../assets/image/imgMobileSugarScratch@2x.png")
    ).default,
  },

  image: {
    // rewards
    BG_JOKER_REWARDS_HEADER: [
      (await import("../assets/image/Rewards/bgImage-rewards@1x.webp")).default,
      (await import("../assets/image/Rewards/bgImage-rewards@2x.webp")).default,
      (await import("../assets/image/Rewards/bgImage-rewards@3x.webp")).default,
    ],
    JOKER_REWARDS_HEADER: [
      (await import("../assets/image/Rewards/image-rewards-hero@1x.webp"))
        .default,
      (await import("../assets/image/Rewards/image-rewards-hero@2x.webp"))
        .default,
      (await import("../assets/image/Rewards/image-rewards-hero@3x.webp"))
        .default,
    ],
    REWARDS_PROGRAM_SHARE: [
      (await import("../assets/image/Rewards/image-invite-friends@1x.webp"))
        .default,
      (await import("../assets/image/Rewards/image-invite-friends@2x.webp"))
        .default,
      (await import("../assets/image/Rewards/image-invite-friends@3x.webp"))
        .default,
    ],
    REWARDS_PROGRAM_TOP_PLAYER: [
      (await import("../assets/image/Rewards/image-rise-to-top@1x.webp"))
        .default,
      (await import("../assets/image/Rewards/image-rise-to-top@2x.webp"))
        .default,
      (await import("../assets/image/Rewards/image-rise-to-top@3x.webp"))
        .default,
    ],
    REFFERAL: [
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-01@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-01@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-01@3x.webp"
        )
      ).default,
    ],
    GRAPH: [
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-02@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-02@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-02@3x.webp"
        )
      ).default,
    ],
    CLIMB_RANK: [
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-03@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-03@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-03@3x.webp"
        )
      ).default,
    ],

    UNLOCK_PERKS: [
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-04@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-04@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-04@3x.webp"
        )
      ).default,
    ],
    DOUBLE_POINTS: [
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-05@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-05@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-05@3x.webp"
        )
      ).default,
    ],
    REDEEM_REWARDS: [
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-06@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-06@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/Rewards/image-rewards-carousel-06@3x.webp"
        )
      ).default,
    ],

    // Support
    BG_JOKER_SUPPORT_HEADER: [
      (await import("../assets/image/Support/bgimage-support@1x.webp")).default,
      (await import("../assets/image/Support/bgimage-support@3x.webp")).default,
      (await import("../assets/image/Support/bgimage-support@3x.webp")).default,
    ],
    JOKER_SUPPORT_HEADER: [
      (await import("../assets/image/Support/image-support-hero@1x.webp"))
        .default,
      (await import("../assets/image/Support/image-support-hero@2x.webp"))
        .default,
      (await import("../assets/image/Support/image-support-hero@3x.webp"))
        .default,
    ],
    SUPPORT_JOIN_GAME: [
      (await import("../assets/image/Support/bgimage-jointhegame@1x.webp"))
        .default,
      (await import("../assets/image/Support/bgimage-jointhegame@2x.webp"))
        .default,
      (await import("../assets/image/Support/bgimage-jointhegame@3x.webp"))
        .default,
    ],
    SUPPORT_TUTORIAL_VIDEOS: [
      (await import("../assets/image/Support/bgimage-howtoplay@1x.webp"))
        .default,
      (await import("../assets/image/Support/bgimage-howtoplay@2x.webp"))
        .default,
      (await import("../assets/image/Support/bgimage-howtoplay@3x.webp"))
        .default,
    ],

    // Download
    BG_JOKER_DOWNLOAD_HEADER: [
      (await import("../assets/image/Download/bgImage-download@1x.jpg"))
        .default,
      (await import("../assets/image/Download/bgImage-download@2x.jpg"))
        .default,
      (await import("../assets/image/Download/bgImage-download@3x.jpg"))
        .default,
    ],
    JOKER_DOWNLOAD_HEADER: [
      (await import("../assets/image/Download/image-jokerPro-hero@1x.webp"))
        .default,
      (await import("../assets/image/Download/image-jokerPro-hero@2x.webp"))
        .default,
      (await import("../assets/image/Download/image-jokerPro-hero@3x.webp"))
        .default,
    ],

    // Main & download
    BG_LUCKY_7: [
      (await import("../assets/image/Main/image-lucky7-phone01@1x.webp"))
        .default,
      (await import("../assets/image/Main/image-lucky7-phone01@2x.webp"))
        .default,
      (await import("../assets/image/Main/image-lucky7-phone01@3x.webp"))
        .default,
    ],
    BG_SLOTS: [
      (await import("../assets/image/Main/image-slots-phone01@1x.webp"))
        .default,
      (await import("../assets/image/Main/image-slots-phone01@2x.webp"))
        .default,
      (await import("../assets/image/Main/image-slots-phone01@3x.webp"))
        .default,
    ],
    BG_NEON_SCRATCH: [
      (await import("../assets/image/Main/image-jokerscratch-01@1x.webp"))
        .default,
      (await import("../assets/image/Main/image-jokerscratch-01@2x.webp"))
        .default,
      (await import("../assets/image/Main/image-jokerscratch-01@3x.webp"))
        .default,
    ],
    BG_SUGAR_SCRATCH: [
      (await import("../assets/image/Main/image-jokerscratch-02@1x.webp"))
        .default,
      (await import("../assets/image/Main/image-jokerscratch-02@2x.webp"))
        .default,
      (await import("../assets/image/Main/image-jokerscratch-02@3x.webp"))
        .default,
    ],

    // Learn
    BG_JOKER_LEARN_HEADER: [
      (await import("../assets/image/Learn/bgImage-learn@1x.webp")).default,
      (await import("../assets/image/Learn/bgImage-learn@2x.webp")).default,
      (await import("../assets/image/Learn/bgImage-learn@3x.webp")).default,
    ],
    JOKER_LEARN_HEADER: [
      (await import("../assets/image/Learn/image-learn-hero@1x.webp")).default,
      (await import("../assets/image/Learn/image-learn-hero@2x.webp")).default,
      (await import("../assets/image/Learn/image-learn-hero@3x.webp")).default,
    ],
    POSTER_AUS: [
      (await import("../assets/image/Learn/posterAUS4D@1x.webp")).default,
      (await import("../assets/image/Learn/posterAUS4D@2x.webp")).default,
      (await import("../assets/image/Learn/posterAUS4D@3x.webp")).default,
    ],
    POSTER_LUCKY_BALL: [
      (await import("../assets/image/Learn/posterLucky7@1x.webp")).default,
      (await import("../assets/image/Learn/posterLucky7@2x.webp")).default,
      (await import("../assets/image/Learn/posterLucky7@3x.webp")).default,
    ],
    POSTER_THREE_BALL: [
      (await import("../assets/image/Learn/posterThreeBall@1x.webp")).default,
      (await import("../assets/image/Learn/posterThreeBall@2x.webp")).default,
      (await import("../assets/image/Learn/posterThreeBall@3x.webp")).default,
    ],
    POSTER_MISS_MATCH: [
      (await import("../assets/image/Learn/posterMissMatch@1x.webp")).default,
      (await import("../assets/image/Learn/posterMissMatch@2x.webp")).default,
      (await import("../assets/image/Learn/posterMissMatch@3x.webp")).default,
    ],
    POSTER_ODDS_EVEN: [
      (await import("../assets/image/Learn/posterOddsEvens@1x.webp")).default,
      (await import("../assets/image/Learn/posterOddsEvens@2x.webp")).default,
      (await import("../assets/image/Learn/posterOddsEvens@3x.webp")).default,
    ],
    POSTER_SINGLE_BET: [
      (await import("../assets/image/Learn/posterSingle@1x.webp")).default,
      (await import("../assets/image/Learn/posterSingle@2x.webp")).default,
      (await import("../assets/image/Learn/posterSingle@3x.webp")).default,
    ],
    POSTER_TRADITIONAL_BET: [
      (await import("../assets/image/Learn/posterTraditional@1x.webp")).default,
      (await import("../assets/image/Learn/posterTraditional@2x.webp")).default,
      (await import("../assets/image/Learn/posterTraditional@3x.webp")).default,
    ],
    POSTER_PACKAGE_BET: [
      (await import("../assets/image/Learn/posterPackage@1x.webp")).default,
      (await import("../assets/image/Learn/posterPackage@2x.webp")).default,
      (await import("../assets/image/Learn/posterPackage@3x.webp")).default,
    ],

    // Scratch
    BG_JOKER_SCRATCH_HEADER: [
      (
        await import(
          "../assets/image/JokerScratch/bgImage-jokerScratch@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/bgImage-jokerScratch@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/bgImage-jokerScratch@3x.webp"
        )
      ).default,
    ],
    JOKER_SCRATCH_HEADER: [
      (
        await import(
          "../assets/image/JokerScratch/image-jokerScratch-hero@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-jokerScratch-hero@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-jokerScratch-hero@3x.webp"
        )
      ).default,
    ],

    TURBO_SCRATCH_1: [
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-01@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-01@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-01@3x.webp"
        )
      ).default,
    ],
    TURBO_SCRATCH_2: [
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-02@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-02@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-02@3x.webp"
        )
      ).default,
    ],
    TURBO_SCRATCH_3: [
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-03@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-03@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-03@3x.webp"
        )
      ).default,
    ],
    TURBO_SCRATCH_4: [
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-04@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-04@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-turboScratch-carousel-04@3x.webp"
        )
      ).default,
    ],

    // JokerScratch - Sugar Scratch
    SUGAR_SCRATCH_1: [
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-01@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-01@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-01@3x.webp"
        )
      ).default,
    ],
    SUGAR_SCRATCH_2: [
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-02@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-02@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-02@3x.webp"
        )
      ).default,
    ],
    SUGAR_SCRATCH_3: [
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-03@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-03@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-carousel-03@3x.webp"
        )
      ).default,
    ],

    //need to replace
    LANDSCAPE_TURBO_SCRATCH: [
      (
        await import(
          "../assets/image/JokerScratch/landscape-turboscratch@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/landscape-turboscratch@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/landscape-turboscratch@3x.webp"
        )
      ).default,
    ],

    LANDSCAPE_SUGAR_SCRATCH: [
      (
        await import(
          "../assets/image/JokerScratch/landscape-sugarscratch@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/landscape-sugarscratch@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/landscape-sugarscratch@3x.webp"
        )
      ).default,
    ],

    JOKERPRO_TURBO_BG: [
      (await import("../assets/image/JokerScratch/jokerScratchTurboBG@1x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/jokerScratchTurboBG@2x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/jokerScratchTurboBG@3x.webp"))
        .default,
    ],

    JOKERPRO_TURBO_GSAP_1: [
      (await import("../assets/image/JokerScratch/turboLeftPhone@1x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/turboLeftPhone@2x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/turboLeftPhone@3x.webp"))
        .default,
    ],

    JOKERPRO_TURBO_GSAP_2: [
      (await import("../assets/image/JokerScratch/turboRightPhone@1x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/turboRightPhone@2x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/turboRightPhone@3x.webp"))
        .default,
    ],

    JOKERPRO_SUGAR_BG: [
      (await import("../assets/image/JokerScratch/jokerScratchSugarBG@1x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/jokerScratchSugarBG@1x.webp"))
        .default,
      (await import("../assets/image/JokerScratch/jokerScratchSugarBG@1x.webp"))
        .default,
    ],

    JOKERPRO_SUGAR_GSAP_1: [
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-sidephone01@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-sidephone01@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-sidephone01@3x.webp"
        )
      ).default,
    ],

    JOKERPRO_SUGAR_GSAP_2: [
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-sidephone02@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-sidephone02@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarScratch-sidephone02@3x.webp"
        )
      ).default,
    ],

    JOKERPRO_SUGAR_GSAP_MIDDLE: [
      (
        await import(
          "../assets/image/JokerScratch/image-sugarscratch-middlephone@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarscratch-middlephone@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerScratch/image-sugarscratch-middlephone@3x.webp"
        )
      ).default,
    ],

    // Joker Pro
    BG_JOKER_PRO_HEADER: [
      (await import("../assets/image/JokerPro/bgImage-jokerPro@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/bgImage-jokerPro@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/bgImage-jokerPro@3x.webp"))
        .default,
    ],
    JOKER_PRO_HEADER: [
      (await import("../assets/image/JokerPro/image-jokerPro-hero@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-jokerPro-hero@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-jokerPro-hero@3x.webp"))
        .default,
    ],

    AUS_4D: [
      (await import("../assets/image/JokerPro/image-aus-4d@1x.webp")).default,
      (await import("../assets/image/JokerPro/image-aus-4d@2x.webp")).default,
      (await import("../assets/image/JokerPro/image-aus-4d@3x.webp")).default,
    ],
    LUCKY_BALL: [
      (await import("../assets/image/JokerPro/image-lucky-ball@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-lucky-ball@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-lucky-ball@3x.webp"))
        .default,
    ],
    THREE_BALL: [
      (await import("../assets/image/JokerPro/image-Three-ball@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-Three-ball@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-Three-ball@3x.webp"))
        .default,
    ],
    MISS_MATCH: [
      (await import("../assets/image/JokerPro/image-MissMatch@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-MissMatch@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-MissMatch@3x.webp"))
        .default,
    ],
    EVEN_ODDS: [
      (await import("../assets/image/JokerPro/image-OddsEvens@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-OddsEvens@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-OddsEvens@3x.webp"))
        .default,
    ],
    SINGLE_BET: [
      (await import("../assets/image/JokerPro/image-single@1x.webp")).default,
      (await import("../assets/image/JokerPro/image-single@2x.webp")).default,
      (await import("../assets/image/JokerPro/image-single@3x.webp")).default,
    ],
    TRADITIONAL_BET: [
      (await import("../assets/image/JokerPro/image-traditional@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-traditional@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-traditional@3x.webp"))
        .default,
    ],
    PRO_BET: [
      (await import("../assets/image/JokerPro/image-pro@1x.webp")).default,
      (await import("../assets/image/JokerPro/image-pro@2x.webp")).default,
      (await import("../assets/image/JokerPro/image-pro@3x.webp")).default,
    ],
    PACKAGE_BET: [
      (await import("../assets/image/JokerPro/image-package@1x.webp")).default,
      (await import("../assets/image/JokerPro/image-package@2x.webp")).default,
      (await import("../assets/image/JokerPro/image-package@3x.webp")).default,
    ],

    // Landscape images
    LANDSCAPE_LOTTO_4D: [
      (await import("../assets/image/JokerPro/image-4dGirl@1x.webp")).default,
      (await import("../assets/image/JokerPro/image-4dGirl@2x.webp")).default,
      (await import("../assets/image/JokerPro/image-4dGirl@3x.webp")).default,
    ],
    LANDSCAPE_LUCKY7: [
      (await import("../assets/image/JokerPro/image-luckyGirl@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-luckyGirl@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-luckyGirl@3x.webp"))
        .default,
    ],

    JOKERPRO_LUCKY7_BG: [
      (await import("../assets/image/JokerPro/image-jokerProLucky@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-jokerProLucky@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-jokerProLucky@3x.webp"))
        .default,
    ],

    JOKERPRO_LUCKY7_GSAP_1: [
      (
        await import(
          "../assets/image/JokerPro/image-gsap-lucky7-iphone01@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerPro/image-gsap-lucky7-iphone01@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerPro/image-gsap-lucky7-iphone01@3x.webp"
        )
      ).default,
    ],

    JOKERPRO_LUCKY7_GSAP_2: [
      (
        await import(
          "../assets/image/JokerPro/image-gsap-lucky7-iphone02@1x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerPro/image-gsap-lucky7-iphone02@2x.webp"
        )
      ).default,
      (
        await import(
          "../assets/image/JokerPro/image-gsap-lucky7-iphone02@3x.webp"
        )
      ).default,
    ],

    JOKERPRO_LOTTO4D_BG: [
      (await import("../assets/image/JokerPro/image-jokerPro4D@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-jokerPro4D@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-jokerPro4D@3x.webp"))
        .default,
    ],

    JOKERPRO_LOTTO4D_GSAP_1: [
      (await import("../assets/image/JokerPro/image-gsap-4D-iphone01@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-gsap-4D-iphone01@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-gsap-4D-iphone01@3x.webp"))
        .default,
    ],

    JOKERPRO_LOTTO4D_GSAP_2: [
      (await import("../assets/image/JokerPro/image-gsap-4D-iphone02@1x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-gsap-4D-iphone02@2x.webp"))
        .default,
      (await import("../assets/image/JokerPro/image-gsap-4D-iphone02@3x.webp"))
        .default,
    ],
  },
};

export default AssetsPack;
